import { RouteLink } from '@47ng/chakra-next'
import { Container, FlexProps, forwardRef, HStack } from '@chakra-ui/react'
import { AnimatedLogo } from 'modules/ui/logos/animatedLogo'
import { ColorModeSwitch } from 'modules/ui/system/colorModeSwitch'
import React from 'react'

interface PublicNavHeaderProps extends FlexProps {}

export const PublicNavHeader = forwardRef<PublicNavHeaderProps, 'header'>(
  ({ ...props }, ref) => {
    return (
      <Container
        as="header"
        display="flex"
        alignItems="center"
        flexWrap="wrap"
        maxW="6xl"
        px={4}
        py={2}
        ref={ref}
        {...props}
      >
        <HStack as="nav" aria-label="Links" spacing={0}>
          <RouteLink to="/">
            <AnimatedLogo mr={8} />
          </RouteLink>
        </HStack>
        <HStack as="nav" aria-label="Shortcuts" ml="auto">
          <ColorModeSwitch />
        </HStack>
      </Container>
    )
  }
)
